import DocumentService from "@/services-http/sdi/DocumentService";
import { lookup } from "mime-types";
export default {
  name: "ReuseAttachmentMixin",
  methods: {
    async fetchAttachments(movementRecordId) {
      const documentService = new DocumentService();

      return await documentService.FindDocumentByFilters(`?movementRecordId=${movementRecordId}`)
        .then((response) => response.data)
        .then((documents) => {
          if (Array.isArray(documents) && documents.length > 0) {
            return documents.map((document) => ({
              idRecentlyUploaded: document.id,
              id: document.id,
              name: document.name,
              file: {},
              type: lookup(document.name),
              documentTypeId: document.documentType.id,
              titleDocument: document.name,
            }));
          };

          return [];
        })
        .catch((error) => {
          console.error(error);
          return [];
        });
    },
    async fetchAttachmentsMovements(movements) {
      const attachmentsMovements = [];
      for (const movementRecord of movements) {
        const attachments = await this.fetchAttachments(movementRecord.id);
        if (Array.isArray(attachments) && attachments.length > 0) {
          attachmentsMovements.push({
            contractId: parseInt(movementRecord.contractId.toString()),
            planId: parseInt(movementRecord.plan.toString()),
            documents: attachments
          })
        }
      }
      return attachmentsMovements;
    },
  }
}